<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">باقات الصيانة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">باقات الصيانة</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <div class="container-fluid">

        <div class="row">
          <div class="col text-end">
            <router-link to="/packagesSubscriptions" class="btn btn-light me-2">
              <i class="bi bi-people me-1"></i> اشتراكات العملاء
            </router-link>
            <router-link v-if="checkAccess('maintenance_packages_create')" to="/mPackages/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة باقة
            </router-link>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header"><div class="card-title">باقات الصيانة</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />

              <div class="card-body">
                <!-- Filter -->
                <div class="row mb-3">
                  <div class="col-12 col-sm-4 mb-2">
                    <input type="text" v-model="filterTitle" class="form-control" placeholder="اسم الباقة">
                  </div>
                  <div class="col-12 col-sm-3 mb-2">
                    <select v-model="filterActive" class="form-control">
                      <option value="">كل الحالات</option>
                      <option value="true">نشط</option>
                      <option value="false">غير نشط</option>
                    </select>
                  </div>
                  <div class="col-12 col-sm-3 mb-2">
                    <button class="btn btn-secondary me-2" @click="applyFilter()">بحث</button>
                    <button class="btn btn-light" @click="resetFilter()">إلغاء</button>
                  </div>
                </div>

                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>اسم الباقة</th>
                            <th>السعر</th>
                            <th>المدة</th>
                            <th>مرات الاستخدام</th>
                            <th>الخصم</th>
                            <th>الخدمات</th>
                            <th>الحالة</th>
                            <th>اخر تحديث</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ row.title }}</td>
                            <td>{{ row.price }} ر.س</td>
                            <td>{{ row.durationMonths }} شهر</td>
                            <td>{{ row.visitsCount }}</td>
                            <td>{{ row.discountPercentage }}%</td>
                            <td>
                              <span class="badge bg-success me-1">
                                مشمولة: {{ countServices(row, 'included') }}
                              </span>
                              <span class="badge bg-info">
                                خصم: {{ countServices(row, 'discount') }}
                              </span>
                            </td>
                            <td>
                              <span :class="row.isActive? 'badge bg-success' : 'badge bg-secondary'">
                                {{ row.isActive? 'نشط' : 'غير نشط' }}
                              </span>
                            </td>
                            <td>{{ $shortDate(row.updatedAt) }}</td>
                            <td>
                              <router-link :to="`/mPackages/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('maintenance_packages_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('maintenance_packages_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)">
                                <i class="bi bi-trash"></i>
                              </button>
                            </td>
                          </tr>
                          <tr v-if="!rows.length">
                            <td colspan="10" class="text-center text-muted">لا توجد باقات</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';

export default {
  name: 'MaintenancePackagesList',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: 1,
      pages: [],
      filterTitle: '',
      filterActive: '',
    }
  },
  methods: {
    checkAccess,
    countServices(row, type){
      const services = row.MaintenancePackageIssues ?? [];
      return services.filter(item => item.serviceType == type).length;
    },
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let url = `/api/admin/mPackages/list?page=${this.currentPage}`;
      if(this.filterTitle)
        url += `&title=${encodeURIComponent(this.filterTitle)}`;
      if(this.filterActive !== '')
        url += `&isActive=${this.filterActive}`;

      this.$http.get(url).then(({data}) => {
        this.rows = data.rows;
        this.pages = data.pages ?? [this.currentPage];
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    applyFilter(){
      this.currentPage = 1;
      this.getList();
    },
    resetFilter(){
      this.filterTitle = '';
      this.filterActive = '';
      this.currentPage = 1;
      this.getList();
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف الباقة ، لا يمكن استعادتها مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });

      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/mPackages/delete/${id}`).then(() => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          const [message] = this.$globalError(err, true);
          toast(message ?? 'غير قادر على الحذف');
        });
      }
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
  },
  created(){
    this.getList();
  }
}
</script>